const RefreshSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect x="0.5" y="0.5" width="31" height="31" rx="5.5" stroke="#D5D5D5" />
      <path
        d="M10.7704 9.94641C12.222 8.68847 14.0792 7.99726 16 8.00001C20.4184 8.00001 24 11.5816 24 16C24 17.7088 23.464 19.2928 22.552 20.592L20 16H22.4C22.4001 14.7453 22.0314 13.5182 21.3397 12.4714C20.6481 11.4246 19.6639 10.6041 18.5097 10.1121C17.3555 9.62008 16.0822 9.47817 14.848 9.70402C13.6138 9.92987 12.4732 10.5135 11.568 11.3824L10.7704 9.94641ZM21.2296 22.0536C19.778 23.3115 17.9208 24.0027 16 24C11.5816 24 8 20.4184 8 16C8 14.2912 8.536 12.7072 9.448 11.408L12 16H9.6C9.5999 17.2547 9.9686 18.4818 10.6603 19.5286C11.3519 20.5754 12.3361 21.3959 13.4903 21.8879C14.6445 22.3799 15.9178 22.5218 17.152 22.296C18.3862 22.0701 19.5268 21.4865 20.432 20.6176L21.2296 22.0536Z"
        fill="#333333"
      />
    </svg>
  );
};

export default RefreshSvg;
